import { shallowRef, unref } from "vue";
import { produce } from "immer";
import { cloneDeep } from "es-toolkit";
/**
 * @description 원본 객체의 불변성 보장을 위해 사용
 * @param baseState 원본 객체
 */
export const useImmer = (baseState) => {
    const raw = unref(baseState);
    const cloned = cloneDeep(raw);
    const state = shallowRef(cloned);
    const update = (updater) => {
        state.value = produce(state.value, updater);
    };
    return [state, update];
};
